/* fr.ts */

import { generateLocale } from './generate.js';

export default generateLocale([
  'Pseudo',
  'Le pseudo ne peut pas faire moins de 3 octets.',
  'E-mail',
  'Veuillez confirmer votre adresse e-mail.',
  'Site Web',
  'Optionnel',
  'Commentez ici...',
  "Aucun commentaire pour l'instant.",
  'Envoyer',
  "J'aime",
  "Annuler le j'aime",
  'Répondre',
  'Annuler la réponse',
  'Commentaires',
  'Actualiser',
  'Charger plus...',
  'Aperçu',
  'Emoji',
  'Télécharger une image',
  'Il y a quelques secondes',
  'Il y a quelques minutes',
  'Il y a quelques heures',
  'Il y a quelques jours',
  "À l'instant",
  'Téléchargement en cours',
  'Connexion',
  'Déconnexion',
  'Admin',
  'Épinglé',
  'Mots',
  'Veuillez saisir des commentaires entre $0 et $1 mots !\n Nombre actuel de mots : $2',
  'Anonyme',
  'Nains',
  'Hobbits',
  'Ents',
  'Mages',
  'Elfes',
  'Maïar',
  'GIF',
  'Rechercher un GIF',
  'Profil',
  'Approuvé',
  'En attente',
  'Indésirable',
  'Détacher',
  'Le plus ancien',
  'Dernier',
  'Le plus populaire',
  "Qu'en pensez-vous ?",
]);
